import React, { useState } from 'react';
import './login.css';
import { message, Spin } from 'antd'
import axios from 'axios';
import { oneSixSixRequestAddress } from '../config'

export default function Login(props) {
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = useState(false)
    const handleSubmit = e => {
        setLoading(true)
        e.preventDefault();
        // axios.post('https://www.osintsee.com/login', {  
        axios.post(`${oneSixSixRequestAddress}/login`, {   
            username,
            password
          })
        .then(function (response) {
            setLoading(false)
            if (response.data.code === 200 && response.data.msg === '操作成功') {
                props.setToken(response.data.token);
            } else {
                message.error(response.data.msg)
            }
        })
    }
    return(
        <div className="login-wrapper">
            <div className="logo-style logo-position">OsintFusion</div>
            <form onSubmit={handleSubmit} className="login-box">
                <div className="logo-style logo-son-position">OsintFusion</div>
                <label>
                    <div>账户</div>
                    <input type="text" onChange={e => setUserName(e.target.value)}/>
                </label>
                <label>
                    <div>密码</div>
                    <input type="password" onChange={e => setPassword(e.target.value)}/>
                </label>
                <div className='button'>
                    <Spin spinning={loading}>
                        <button type="submit">登录</button>
                    </Spin>
                </div>
            </form>
        </div>
    )
}